export default {
  isNull(str) {
    if (str == "") return true;
    var regu = "^[ ]+$";
    var re = new RegExp(regu);
    return re.test(str);
  },
  isphone(inputString) {
    let myreg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[56]|17[0135678]|18[0-9]|19[89])\d{8}$/;
    //console.log(myreg.test(inputString));
    return myreg.test(inputString) ? true : false;
  },

  /**
   *
   *  检查用户输入的地址是否正确
   * @param {*} receive 收货人姓名
   * @param {*} address 收货人地址
   * @param {*} phone  收货人手机号
   * @returns
   */
  checkAddressIsright(receive, address, phone) {
    let _this = this;
    return new Promise(function(resolve, reject) {
      if (
        _this.isNull(address) ||
        _this.isNull(phone) ||
        _this.isNull(receive)
      ) {
        reject("输入项不能为空");
        return;
      }
      if (!_this.isphone(phone)) {
        reject("请输入正确的手机号");
        return;
      }
      resolve();
    });
  }
};
